var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolidayCheckLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.002,
    height: 24.891,
    x: 0,
    y: 0,
    viewBox: "0 0 120.002 24.891",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.28545 0 0 .28545 -14.558 -14.558)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fad73c",
    d: "M471.3 129.7c0 4.7-3.8 8.5-8.5 8.5s-8.5-3.8-8.5-8.5 3.8-8.5 8.5-8.5 8.5 3.8 8.5 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fad73c",
    d: "M437.4 129.7c0 4.7-3.8 8.5-8.5 8.5s-8.5-3.8-8.5-8.5 3.8-8.5 8.5-8.5 8.5 3.8 8.5 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fad73c",
    d: "M403.4 129.7c0 4.7-3.8 8.5-8.5 8.5s-8.5-3.8-8.5-8.5 3.8-8.5 8.5-8.5 8.5 3.8 8.5 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fad73c",
    d: "M369.4 129.7c0 4.7-3.8 8.5-8.5 8.5s-8.5-3.8-8.5-8.5 3.8-8.5 8.5-8.5 8.5 3.8 8.5 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fad73c",
    d: "M335.4 129.7c0 4.7-3.8 8.5-8.5 8.5s-8.5-3.8-8.5-8.5 3.8-8.5 8.5-8.5 8.5 3.8 8.5 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fad73c",
    d: "M301.3 129.7c0 4.7-3.8 8.5-8.5 8.5s-8.5-3.8-8.5-8.5 3.8-8.5 8.5-8.5 8.5 3.8 8.5 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M104.4 86.2c0-6.9 4.2-13.5 11.4-13.5 7.1 0 11.3 6.7 11.3 13.5 0 6.5-3.5 13.5-11.3 13.5-7.9 0-11.4-7.1-11.4-13.5m-7.1 0c0 10.3 7.6 18.9 18.5 18.9s18.5-8.6 18.5-18.9c0-11-7.4-18.9-18.5-18.9-11.1-.1-18.5 7.9-18.5 18.9m0 0c0 10.3 7.6 18.9 18.5 18.9s18.5-8.6 18.5-18.9c0-11-7.4-18.9-18.5-18.9-11.1-.1-18.5 7.9-18.5 18.9m7.1 0c0-6.9 4.2-13.5 11.4-13.5 7.1 0 11.3 6.7 11.3 13.5 0 6.5-3.5 13.5-11.3 13.5-7.9 0-11.4-7.1-11.4-13.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M257.8 101.8l-12-32.7c0-.1-.1-.2-.1-.3 0-.4.3-.7.8-.7H251.7c.6 0 1.2.4 1.4 1l9.5 28.9h.1l9.6-28.8v-.1c.2-.5.7-.9 1.3-.9h4.7c.4 0 .8.3.8.7v.2l-12.4 34.1-8 23.1c0 .1-.1.2-.1.3-.3.3-.7.4-1.1.1l-4-3.2c-.6-.5-.8-1.1-.5-1.7l6.1-15.8c.1-.4-.9-3-1.3-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M235 90.2V87c-1.4 0-2.9-.1-4.3-.1-3.6 0-12.6.6-12.6 6.9 0 3.8 3.7 5.9 6.8 5.9 6.6 0 10.1-4.1 10.1-9.5m6.9 12.6c0 .8-.7 1.5-1.5 1.5h-3.1c-.9 0-1.6-.6-1.6-1.5v-3.2h-.1c-1.6 2.2-5.1 5.5-11.3 5.5-7.8 0-13.3-3.4-13.3-11.3 0-9.1 10-11.9 16.9-11.9 2.6 0 4.5 0 7.1.1 0-6.2-2.3-9.4-9-9.4-2.9 0-6 .8-8.5 2.3-.2.1-.5.2-.8.2-.8 0-1.4-.6-1.5-1.4l-.2-2.6c0-.3.1-.6.4-.7 3.3-1.9 7.1-3.2 11.6-3.2 10.4 0 14.6 5.1 14.6 15v15c.1 2.6.2 4.3.3 5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M176.5 86c-.1 5.7 2.9 13.7 10.1 13.7 7.6 0 10.7-7.4 10.7-13.5 0-6.7-3.5-13.6-10.8-13.6-7.3 0-10.2 6.8-10 13.4m21 16.7v-3.6h-.1c-1.8 2.7-5.9 6-12.4 6-11 0-15.6-9.7-15.6-19.6 0-9.7 5.1-18.3 15.7-18.3 6.3 0 10 2.5 12.1 5.8h.1V52.5c0-.8.6-1.5 1.4-1.5h3.8c.8 0 1.5.6 1.5 1.5v50.2c0 .8-.6 1.4-1.4 1.5H199c-.8 0-1.5-.7-1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M89.1 102.8c0 .8-.7 1.5-1.5 1.5h-4.2c-.8 0-1.4-.7-1.4-1.5V81.7H58.1v21.1c0 .8-.6 1.4-1.4 1.5h-4.1c-.9 0-1.6-.7-1.6-1.5V56.3c0-.9.7-1.5 1.5-1.5h4.2c.8 0 1.5.7 1.5 1.4v19.2H82V56.1c0-.8.7-1.4 1.5-1.4h4.1c.9 0 1.6.7 1.6 1.5v46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M142.9 104.2h-.1c-.8 0-1.5-.7-1.5-1.5V52.5c0-.8.7-1.5 1.5-1.5H146.6c.8 0 1.5.7 1.5 1.5v51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M158.3 104.2h-.1c-.8 0-1.5-.7-1.5-1.5V69.5c0-.8.7-1.5 1.5-1.5h3.8c.8 0 1.5.7 1.5 1.5v34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M163.8 52.4v6.1c0 .8-.7 1.4-1.5 1.4h-6.1v-6.1c0-.8.7-1.5 1.5-1.5h6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M104.4 86.2c0 6.5 3.5 13.5 11.4 13.5s11.3-7.1 11.3-13.5c0-6.9-4.2-13.5-11.3-13.5-7.2-.1-11.4 6.6-11.4 13.5m-7.1 0c0-11 7.4-18.9 18.5-18.9s18.5 7.9 18.5 18.9c0 10.3-7.6 18.9-18.5 18.9-11 0-18.5-8.6-18.5-18.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M321.9 102.3c0 .7-.4 1.2-.9 1.4-3.6 1.2-7.7 1.4-10.4 1.4-15.8 0-26.2-10.1-26.2-25.8 0-15.2 11.1-25.4 26.3-25.4 3.5 0 6.9.5 10.1 1.7h.1c.5.2.9.7.9 1.3l-.4 4.8c0 .4-.4.7-.7.7-.1 0-.2 0-.3-.1-2.9-1.5-6.1-2.2-9.3-2.2-11.5 0-19.1 8.2-19.1 19.3 0 11.6 8.4 19.4 18.8 19.4 3.1 0 7.2-.7 9.9-1.9.1 0 .2-.1.3-.1.4 0 .7.3.7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M362.3 102.7c0 .8-.7 1.5-1.5 1.5H357c-.8 0-1.5-.7-1.5-1.5V85.5c0-8.4-1.9-12.5-7.7-12.9-7.6 0-11.1 6.1-11.1 14.9v15.3c0 .8-.6 1.4-1.4 1.5h-3.8c-.8 0-1.5-.7-1.5-1.5V52.6c0-.9.7-1.6 1.5-1.6h3.8c.8 0 1.5.7 1.5 1.5v20.7h.1c2.4-3.8 6.6-6 11.7-6 9.4 0 13.6 5.8 13.6 15.5v20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M433.8 102.6c0 .8-.5 1.3-1.1 1.5-2.5.9-5.1 1-7.2 1-11 0-18.5-8.6-18.5-18.9 0-11 7.4-18.9 18.5-18.9 2.2 0 4.9.4 6.9 1 .7.2 1.1.7 1.1 1.4v.1l-.3 3.4c0 .4-.3.7-.8.7h-.2c-2.3-.8-4.5-1.2-6.4-1.2-7.5 0-11.7 6.7-11.7 13.5 0 6.5 3.5 13.5 12.1 13.5 1.9 0 4.3-.5 6.2-1.5.1-.1.2-.1.4-.1.4 0 .7.3.7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M463.5 104.2c-.5 0-.9-.2-1.2-.5l-15.8-18.1v17.1c0 .8-.7 1.5-1.5 1.5h-3.7c-.8 0-1.5-.7-1.5-1.5V52.5c0-.8.7-1.5 1.5-1.5h3.7c.9 0 1.5.7 1.5 1.5v30.2l14.1-14.1c.3-.3.7-.5 1.1-.5h6.7c.4 0 .7.3.7.8 0 .2-.1.4-.2.5l-15.6 14.8 17.8 18.8c.2.1.3.3.3.6 0 .4-.3.7-.7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058a3",
    d: "M376.6 82.7h18.8c0-5.5-3.3-10.1-9.1-10.1-6.5 0-9.2 5.4-9.7 10.1m23.2 19c0 .7-.4 1.2-.9 1.4-2.4.9-5.3 2-10.6 2-12.9 0-18.8-7.8-18.8-19.6 0-10.7 6.8-18.3 17.1-18.3 11.8 0 15.9 8.4 16 19.7 0 .4-.3.8-.7.8h-25.2c0 7.2 5.6 12.1 12 12.1 3.7 0 7.8-1.6 10.1-2.9.1-.1.2-.1.4-.1.4 0 .8.3.8.7v4.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayCheckLogo);
export default __webpack_public_path__ + "static/media/HolidayCheck_Logo.a3b04cb5816438460bc6185672855a36.svg";
export { ForwardRef as ReactComponent };